export default {
  credit: "Credit",
  of: "of",
  photos: "photos",
  subscribe: "Subscribe to access this gallery."
};
